import React, {useEffect, useState} from "react";
import { Form } from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Buttons from "../buttons/button-primary";
import InputEmail from "../inputs/email-input";
import InputPassword from "../inputs/password-input";
import validate from "./loginEmailValidation";
import { login } from '../../redux/actions/login';

const LoginEmail = () => {
    const loginError = useSelector(state => state.login.error);
    const loginSuccess = useSelector(state => state.login.success);
    const loginLoading = useSelector(state => state.login.loading);

    const dispatch = useDispatch();
    const [state, setState] = useState({
        email: "",
        password: "",
        emailError: "",
        passwordError: "",
        valid: false,
        responseError: "",
    });
    const [shouldClearError, setShouldClearError] = useState(false);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        setState((prevProps) => ({
            ...prevProps,
            [event.target.name]: value,
            [`${name}Error`]: "",
        }));
        
        // Set flag to clear error when user starts typing
        if (loginError) {
            setShouldClearError(true);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        // Clear error flag when submitting
        setShouldClearError(false);
        
        const errors = validate(state)
        setState((prevProps) => ({
            ...prevProps,
            ...errors
        }));

        if (errors.valid) {
            dispatch(login({
                email: state.email,
                password: state.password,
                user_type: "3"
            }));
        }
    };

    return (
        <Form className="ebw-entry__tab-form" onSubmit={handleSubmit}>
            <InputEmail
                label="Email"
                name="email"
                id="login_mail"
                error={state.emailError}
                value={state.email}
                changeEvent={handleInputChange}
            />
            <InputPassword
                label="Password"
                name="password"
                id="login_password"
                error={state.passwordError}
                value={state.password}
                changeEvent={handleInputChange}
            />
            {loginError && !shouldClearError ?
                <div className="text-left mb-3" style={{ color: "var(--danger", opacity: "0.9" }}>
                    <div className="ebw-error"> {loginError} </div>
                </div>
                : ""
            }
            <div className="d-flex flex-row justify-content-between align-items-center ml-3 ml-md-2 my-4">
                <div className="ebw-entry__tab-forgot ml-auto">
                    <Link className="mb-0 text-sm ebw-entry__tab-forgot--link" role="button" to="/forgot-password">Forgot Password?</Link>
                </div>
            </div>
            <Buttons type="submit" text={loginLoading ? "Please wait..." : "Login"} disabled={loginLoading} />
        </Form>
    );
}

export default LoginEmail;